import React from "react";
import { Box, Input, Alert, Modal, Button, LayerLoading } from "../../Kit";
import * as yup from "yup";
import Raven from "raven-js";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import { defaults } from "lodash";
import debug from "debug";
import { withFormik } from "formik";
import SelectImage from "../../SelectImage";
import {
  CreateImageResourceMutation,
  UpdateImageResourceMutation
} from "../../API/mutations/ImageMutations";
const log = debug("app:AddVideo");

const ImageForm = ({
  values,
  errors,
  handleChange,
  handleBlur,
  publisherId,
  setFieldValue,
  handleSubmit,
  isSubmitting
}) => (
  <form id="formId" onSubmit={handleSubmit}>
    <Modal.Body>
      <Input
        label="Title *"
        name="title"
        onChange={handleChange}
        error={errors.title}
        onBlur={handleBlur}
        value={values.title}
      />
      <Input
        label="Short description *"
        name="description"
        onChange={handleChange}
        error={errors.description}
        onBlur={handleBlur}
        value={values.description}
      />

      <SelectImage
        accept="application/pdf"
        showSelect={false}
        prompt={"Drop a PDF here, or click to select a PDF to upload"}
        publisherId={publisherId}
        onChange={v => setFieldValue("imageId", v)}
        imageId={values.imageId}
      />

      {errors.general && (
        <Box my={2}>
          <Alert
            type="danger"
            title={
              errors.general ||
              "An unexpected error occurred. Please try again."
            }
          />
        </Box>
      )}
    </Modal.Body>

    <Modal.Footer>
      <Button appearance="primary" mb={0} type="submit" saving={isSubmitting}>
        Save
      </Button>
    </Modal.Footer>
    <LayerLoading loading={isSubmitting} />
  </form>
);

const formConfig = {
  mapPropsToValues: props => {
    let existing = props.resource ? props.resource : {};
    if (existing.meta) {
      existing = {
        ...existing,
        ...existing.meta
      };
    }

    return defaults(existing, {
      title: "",
      description: "",
      imageId: ""
    });
  },
  validateOnBlur: false,
  validateOnChange: false,
  validationSchema: yup.object().shape({
    title: yup
      .string()
      .trim()
      .required("A title is required."),
    description: yup
      .string()
      .trim()
      .required("A description is required."),
    imageId: yup
      .string()
      .trim()
      .required("A file is required.")
  }),
  handleSubmit: async (
    values,
    { resetForm, props, setSubmitting, setErrors }
  ) => {
    const attr = {
      input: {
        title: values.title,
        description: values.description
      },
      imageId: values.imageId
    };

    // handle updates
    if (props.resource) {
      attr.id = props.resource.id;
    } else {
      attr.input.courseId = props.courseId;
    }

    log("saving: %o", attr);

    try {
      const res = await props.mutate({ variables: attr });
      log("mutation response: %o", res);

      resetForm();
      if (props.onRequestClose) {
        props.onRequestClose();
      }
    } catch (err) {
      console.error(err.stack);
      setErrors({ general: err.message });
      Raven.captureException(err);
    }

    setSubmitting(false);
  }
};

const AddImageFormik = withFormik(formConfig)(ImageForm);

const withAddImage = graphql(CreateImageResourceMutation, {
  options: { refetchQueries: ["CourseResources"] }
});

export const AddImage = compose(withAddImage)(AddImageFormik);

const updateImage = graphql(UpdateImageResourceMutation);

export const UpdateImage = compose(updateImage)(AddImageFormik);
